import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-zoomout",
  "use": "icon-zoomout-usage",
  "viewBox": "0 0 174.667 174.858",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 174.667 174.858\" id=\"icon-zoomout\">\r\n<rect x=\"46.667\" y=\"79.859\" fill=\"currentColor\" width=\"81.333\" height=\"11.333\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol